import PayeeTransactionHistory from './PayeeTransactionHistory';

export default PayeeTransactionHistory;
